module.exports = __webpack_public_path__ + "img/11_65.3ff0daab.png";